import { create } from 'zustand';

interface ClipPlaybackState {
  messageIdPlaying: string;
  messagePlayingChanged: (messageId: string) => void;
  autoScroll: boolean;
  autoScrollingChanged: (autoScroll: boolean) => void;
}

export const clipPlaybackStore = create<ClipPlaybackState>(set => {
  return {
    messageIdPlaying: '',
    messagePlayingChanged: messageId => set({ messageIdPlaying: messageId }),
    autoScroll: true,
    autoScrollingChanged: autoScroll => set({ autoScroll }),
  };
});
